import {
  DashboardOutlined,
  EyeOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  AppstoreAddOutlined,
  MenuOutlined,
  ShoppingOutlined,
  ShopOutlined,
  TagsOutlined,
  PictureOutlined,
  FileTextOutlined,
  UnorderedListOutlined,
  TeamOutlined,
  SolutionOutlined,
  MailOutlined,
} from "@ant-design/icons";

// ⚠️ นี่คือจุดเดียวที่ต้องแก้เมื่ออยากเพิ่ม/ลบ/แก้เมนู admin
// ทุกครั้งที่เพิ่ม route ใหม่ใน App.js (ที่ไม่ใช่ route แบบ dynamic เช่น /:id)
// ให้เพิ่ม 1 รายการที่นี่ด้วย เมนูฝั่งซ้ายจะอัปเดตตามอัตโนมัติ ไม่ต้องไปแก้ไฟล์ MenubarAdmin.jsx เลย
export const ADMIN_MENU_GROUPS = [
  {
    label: "ภาพรวม",
    items: [
      { path: "/admin/index", label: "แดชบอร์ด", icon: DashboardOutlined },
      { path: "/admin/visit", label: "สถิติผู้เข้าชม", icon: EyeOutlined },
      { path: "/admin/chart-sell", label: "บทวิเคราะห์ยอดขาย", icon: BarChartOutlined },
    ],
  },
  {
    label: "จัดการเนื้อหา",
    items: [
      { path: "/admin/create-category", label: "เพิ่มหมวดหมู่ 360", icon: AppstoreOutlined },
      { path: "/admin/create-category-service", label: "เพิ่มหมวดหมู่บริการ", icon: AppstoreAddOutlined },
      { path: "/admin/create-menu", label: "เพิ่มเมนูหมวดหมู่หน้าแรก", icon: MenuOutlined },
      { path: "/admin/create-product", label: "เพิ่มสินค้า", icon: ShoppingOutlined },
      { path: "/admin/create-product-service", label: "เพิ่มสินค้าบริการ", icon: ShopOutlined },
      { path: "/admin/promotion-product", label: "จัดโปรโมชัน", icon: TagsOutlined },
      { path: "/admin/panel", label: "จัดรูปภาพโปรโมท", icon: PictureOutlined },
    ],
  },
  {
    label: "คำสั่งซื้อ",
    items: [
      { path: "/admin/orders", label: "จัดการ Orders", icon: FileTextOutlined },
      { path: "/admin/branch", label: "สั่งซื้อสาขา", icon: ShopOutlined },
      { path: "/admin/branch-list", label: "รายการสั่งซื้อสาขา", icon: UnorderedListOutlined },
    ],
  },
  {
    label: "ผู้ใช้งานและพาร์ทเนอร์",
    items: [
      { path: "/admin/manage-admin", label: "จัดการผู้ใช้งาน", icon: TeamOutlined },
      { path: "/admin/partner", label: "จัดการพาร์ทเนอร์", icon: SolutionOutlined },
      { path: "/admin/partner-leads", label: "ส่งอีเมลเชิญพาร์ทเนอร์", icon: MailOutlined },
    ],
  },
];